export const WeightMeasurementSystem = { Metric: 'METRIC', Imperial: 'IMPERIAL' };

export const WeightMeasurementUnits = { Kilograms: 'kg', Grams: 'g', Pounds: 'lb' };

export const weightMeasurementSystemOptions = [
  {
    label: `Metric (${WeightMeasurementUnits.Kilograms}, ${WeightMeasurementUnits.Grams})`,
    value: WeightMeasurementSystem.Metric,
  },
  { label: `Imperial (${WeightMeasurementUnits.Pounds})`, value: WeightMeasurementSystem.Imperial },
];

export const weightMeasurementSystemUnits = {
  // metric base - grams
  g: {
    [WeightMeasurementSystem.Metric]: WeightMeasurementUnits.Grams,
    [WeightMeasurementSystem.Imperial]: WeightMeasurementUnits.Pounds,
  },
  // metric base - kilograms
  kg: {
    [WeightMeasurementSystem.Metric]: WeightMeasurementUnits.Kilograms,
    [WeightMeasurementSystem.Imperial]: WeightMeasurementUnits.Pounds,
  },
};

export const localeStringUnit = {
  [WeightMeasurementUnits.Kilograms]: 'kilogram',
  [WeightMeasurementUnits.Grams]: 'gram',
  [WeightMeasurementUnits.Pounds]: 'pound',
};

export const queryParamUnit = {
  [WeightMeasurementUnits.Kilograms]: 'KG',
  [WeightMeasurementUnits.Grams]: 'G',
  [WeightMeasurementUnits.Pounds]: 'LB',
};

// CONVERSION FACTORS
export const GRAMS_PER_POUND = 453.59237;
export const POUNDS_PER_GRAM = 1 / GRAMS_PER_POUND;
